const rules = {
	cups: {
		type: 'number',
		range: [1, 666]
	},
	band: {
		type: 'number',
		range: [1, 666]
	},
	brand: {
		type: 'text'
	}
}

export default rules;